import Editor from "../../Components/common/Editor";
import trans from "./../../../Languages/Languages";
import { useState } from "react";
import { Button, Card, message } from "antd";
import React, { useEffect } from "react";
import API from "../../../API";
import { useLocation } from "react-router";
import { usePageContext } from "../../../Context/PageContext";

const AcademicHelp = () => {
  const [editorHtml, setEditorHtml] = useState("");
  const [loading, setLoading] = useState(false);


  const [pageData, setPageData] = useState(null);
  const [isRenaming, setIsRenaming] = useState(false);
  const [renameValue, setRenameValue] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });
  const { triggerRefresh } = usePageContext();

  const handleTextEditorChange = (html) => {
    setEditorHtml(html);
  };
  const currentDegreeID = window.location.hash.split("/")[3];
  const location = useLocation();
  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///                  Use Effect
  ////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    setLoading(true);
    const init = async () => {
      await API.get(`/admin/degree/${currentDegreeID}`)
        .then((res) => {
          setPageData(res.data.academicHelpLabel);
          setRenameValue(res.data.academicHelpLabel?.title);
          if (res.data.degree.help.length > 0) {
            setEditorHtml(res.data.degree.help[0].about);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    };
    init();
  }, [currentDegreeID, location]);
  const handleSaveSection = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("about", editorHtml);

    await API.post(
      `/admin/degree/academic/help/update/${currentDegreeID}`,
      formData
    )
      .then((res) => {
        message.success("Saved Successfully", 3);
        setLoading(false);
      })
      .catch((err) => {
        message.error("Something went wrong, please try again", 3);
        setLoading(false);
      });
  };

  // Hide context menu on outside click
  useEffect(() => {
    const handleClickOutside = () => {
      setShowContextMenu(false);
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);


  const handleRenameSubmit = async () => {
    try {
      await API.put(`/admin/pages/slug/${pageData.slug}`, {
        title: renameValue,
      });
      setPageData((prev) => ({
        ...prev,
        title: renameValue,
      }));
      setIsRenaming(false);
      triggerRefresh(); // 🔁 this triggers sidebar reload
    } catch (err) {
      message.error("Rename failed");
    }
  };
  return (
    <div className="pages-container">
      <Card loading={loading} bordered={false}>
        <div className="content-wrapper">
          {/*  text */}

          {/* Tuition Fees */}
          <div className="bg-content-container mb-0">
          <div style={{ position: "relative" }}>
                <div
                  className="fw-600 mb-2"
                  onDoubleClick={() => setIsRenaming(true)}
                  onContextMenu={(e) => {
                    e.preventDefault();
                    setContextMenuPos({ x: e.clientX, y: e.clientY });
                    setShowContextMenu(true);
                  }}
                >
                  {isRenaming ? (
                    <input
                      type="text"
                      value={renameValue}
                      autoFocus
                      onChange={(e) => setRenameValue(e.target.value)}
                      onBlur={handleRenameSubmit}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleRenameSubmit();
                      }}
                      style={{ padding: "2px 6px", fontSize: "14px" }}
                    />
                  ) : (
                    pageData?.title || "Loading..."
                  )}
                </div>

                {showContextMenu && (
                  <ul
                    style={{
                      position: "fixed",
                      top: contextMenuPos.y,
                      left: contextMenuPos.x,
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      listStyle: "none",
                      padding: "5px 10px",
                      margin: 0,
                      zIndex: 1000,
                      cursor: "pointer",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    }}
                    onClick={() => {
                      setIsRenaming(true);
                      setShowContextMenu(false);
                    }}
                    onMouseLeave={() => setShowContextMenu(false)}
                  >
                    <li>{trans.Rename}</li>
                  </ul>
                )}
              </div>
            <Editor
              key="academicHelp"
              editorHtml={editorHtml}
              setEditorHtml={setEditorHtml}
              handleChange={handleTextEditorChange}
            />
          </div>
        </div>
        {/* save changes */}

        <Button
          onClick={handleSaveSection}
          className="btn-save-changes"
          type="primary"
          htmlType="submit"
        >
          {trans.Save}
        </Button>
      </Card>
    </div>
  );
};

export default AcademicHelp;
